import service from '@/store/services/product-category-service';

const state = {
  list: {},
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
};

const actions = {
  read({ commit }, params) {
    return service.read(params)
      .then(async ({ product_categories }) => {
        await commit('SET_LIST', product_categories);
        return Promise.resolve(product_categories);
      }).catch((error) => {
        return Promise.reject(error);
      });
  },
};

const getters = {
  list: state => state.list,
};

const product_category = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default product_category;
